/* CAMODE premium rail navigation without visible arrows.
   Native touch swipe, mouse-drag, Shift+wheel, keyboard focus.
   Never intercept vertical scrolling or ordinary product-card taps. */
(function(){
  'use strict';
  if(window.__camodePremiumRailInstalled)return;
  window.__camodePremiumRailInstalled=true;
  function initRail(rail){
    if(rail.dataset.cmRailReady)return;
    rail.dataset.cmRailReady='1';
    var down=false, moved=false, x=0, scroll=0;
    rail.addEventListener('pointerdown',function(e){
      if(e.pointerType!=='mouse'||e.button!==0)return;
      down=true;moved=false;x=e.clientX;scroll=rail.scrollLeft;
    });
    document.addEventListener('pointermove',function(e){
      if(!down)return;
      var delta=e.clientX-x;
      if(Math.abs(delta)>6){moved=true;rail.classList.add('cm-rail--grabbing');rail.scrollLeft=scroll-delta;}
    });
    document.addEventListener('pointerup',function(){down=false;rail.classList.remove('cm-rail--grabbing');});
    document.addEventListener('pointercancel',function(){down=false;rail.classList.remove('cm-rail--grabbing');});
    rail.addEventListener('click',function(e){
      if(moved){e.preventDefault();e.stopImmediatePropagation();moved=false;}
    },true);
    rail.addEventListener('wheel',function(e){
      if(e.shiftKey&&Math.abs(e.deltaY)>0){
        if(rail.scrollWidth>rail.clientWidth){rail.scrollLeft+=e.deltaY;e.preventDefault();}
      }
    },{passive:false});
  }
  function init(){document.querySelectorAll('.cm-outfit__rail,.cm-premium-brand__rail,.cm-rotate__cards').forEach(initRail);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();